export const TrfForm = {
  Snackbar: {
    maxWidth: '324px',
    margin: '0 auto',
  },
  ErrorCollection: {
    maxWidth: '324px',
    marginBottom: '36px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  None: {
    display: 'none',
  },
  BottomMargin: {
    marginBottom: '100px',
  },
  IconContainer: {
    display: 'flex',
    gap: '16px',
  },
  CollectedBox: {
    marginTop: '8px',
    backgroundColor: '#ffffff',
    paddingBottom: '12rem !important',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.06)',
  },
  AddedName: {
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  LoginAlert: {
    marginTop: '28px',
    marginRight: '8px',
    alignItems: 'center',
    display: 'flex',
    height: 48,
    borderRadius: 12,
    backgroundColor: '#01b37a',
    color: '#fff',
    '.MuiAlert-icon': {
      marginRight: '8px',
    },
    maxWidth: '312px',
    maxHeight: '48px',
  },
  ErrorAlert: {
    marginTop: '28px',
    marginRight: '8px',
    alignItems: 'center',
    display: 'flex',
    height: 48,
    borderRadius: 12,
    backgroundColor: '#F4511E',
    color: '#fff',
    '.MuiAlert-icon': {
      marginRight: '8px',
      color: '#fff!important',
    },
    maxWidth: '312px',
    maxHeight: '48px',
  },
  UploadedAlert: {
    marginTop: '28px',
    marginRight: '8px',
    alignItems: 'center',
    display: 'flex',
    height: 48,
    width: '312px',
    borderRadius: 12,
    backgroundColor: '#01b37a',
    color: '#fff',
    '.MuiAlert-icon': {
      marginRight: '8px',
    },
    maxWidth: '312px',
    maxHeight: '48px',
  },
  UploadedAlertError: {
    marginTop: '28px',
    marginRight: '8px',
    alignItems: 'center',
    display: 'flex',
    height: 48,
    width: '312px',
    backgroundColor: '#e74c3c',
    color: '#fff',
    borderRadius: 12,
    '.MuiAlert-icon': {
      marginRight: '8px',
      color: 'white',
    },
    maxWidth: '312px',
    maxHeight: '48px',
  },
  CheckIcon: {
    marginLeft: '8px',
  },
  WelcomeBack: {
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#ffffff',
  },
  Container: {
    backgroundColor: '#fff',
  },
  Box: {
    margin: 'auto',
    border: 'none',
  },
  BoxHidden: {
    display: 'none',
    margin: 'auto',
    border: 'none',
  },
  PartnerCard: {
    margin: 'auto',
    minHeight: 300,
    backgroundColor: '#ffffff',
    borderRadius: 'none',
    boxShadow: 'none',
  },
  PartnerCardHidden: {
    display: 'none',
    margin: 'auto',
    minHeight: 300,
    backgroundColor: '#ffffff',
    borderRadius: 'none',
    boxShadow: 'none',
  },
  TrfCard: {
    margin: '0 auto',
    backgroundColor: '#ffffff',
    borderRadius: 'none',
    boxShadow: 'none',
  },
  TrfHeaderBox: {
    display: 'flex',
    marginBottom: '16px',
  },
  PartnerDetails: {
    marginLeft: '16px',
    marginTop: '16px',
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  PartnerTypeFormControl: {
    marginLeft: '12px',
    marginTop: '8px',
    '.MuiFormControlLabel-label': {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      color: '#3c3c3c',
    },
  },
  TrfCount: {
    marginTop: '16px',
    marginRight: '16px',
    flex: 'none',
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'right',
    color: '#616161',
  },
  TrfHeading: {
    width: '100%',
    marginLeft: '16px',
    marginTop: '16px',
    paddingBottom: '8px',
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  Clinic: {
    marginLeft: '16px',
    marginTop: '13px',
    width: 40,
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  Partner: {
    marginLeft: '16px',
    marginTop: '10px',
    width: 54,
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  PartnerId: {
    position: 'relative',
    marginLeft: '16px',
    top: '19px',
    display: 'inline',
    width: 74,
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  SubHeading: {
    display: 'inline',
    marginLeft: '16px',
    top: '8px',
    width: 93,
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  SubHeadingId: {
    position: 'relative',
    marginLeft: '16px',
    top: '18px',
    width: 93,
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  SelectDropdown: {
    marginLeft: '16px',
    marginTop: '8px',
    width: `calc(${window.screen.width}px - 32px)`,
    maxHeight: 48,
    minHeight: 48,
    borderRadius: 2,
    '& > .MuiSvgIcon-root': {
      right: '16px',
    },
    '.MuiButtonBase-root': {
      right: '8px',
    },
    '& > .MuiSelect-outlined': {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#3c3c3c',
    },
    '.MuiInputBase-root': {
      maxHeight: 48,
      minHeight: 48,
      padding: 0,
      borderRadius: 2,
    },
    '#tags-filled': {
      marginLeft: '8px',
      height: 16,
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#3c3c3c',
    },
    '.MuiFormLabel-root': {
      height: 16,
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#3c3c3c',
    },
    'input::placeholder': {
      color: '#3c3c3c',
      opacity: 1,
    },
  },
  SelectDropdownError: {
    marginLeft: '16px',
    marginTop: '8px',
    width: `calc(${window.screen.width}px - 32px)`,
    maxHeight: 48,
    minHeight: 48,
    borderRadius: 2,
    '& > .MuiSvgIcon-root': {
      right: '16px',
    },
    '.MuiButtonBase-root': {
      right: '8px',
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: 'red',
    },
    '& > .MuiSelect-outlined': {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#3c3c3c',
    },
    '.MuiInputBase-root': {
      maxHeight: 48,
      minHeight: 48,
      padding: 0,
      borderRadius: 2,
    },
    '#tags-filled': {
      marginLeft: '8px',
      height: 16,
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#3c3c3c',
    },
    '.MuiFormLabel-root': {
      height: 16,
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
      fontStyle: 'normal',
      letterSpacing: 0,
      color: '#3c3c3c',
    },
    'input::placeholder': {
      color: '#3c3c3c',
      opacity: 1,
    },
  },
  ClinicError: {
    marginTop: '6px',
    marginLeft: '16px',
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#fe0a0a',
  },
  ClinicErrorNone: {
    display: 'none',
  },
  MenuItem: {
    width: 160,
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    lineHeight: 16,
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  MenuProps: {
    maxHeight: 100,
  },
  MenuTypography: {
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  Button: {
    marginTop: '16px',
    marginBottom: '16px',
    width: `calc(${window.screen.width}px - 32px)`,
    height: 40,
    borderRadius: 2,
    backgroundColor: '#ffffff',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ff970a',
    color: '#ff970a',
  },
  ButtonContainer: {
    marginTop: '16px',
    marginRight: '16px',
    marginLeft: '16px',
    borderTop: 2,
    borderColor: '#f1f1f1',
  },
  ButtonSubmitted: {
    display: 'none',
    marginLeft: '16px',
    marginTop: '16px',
    marginBottom: '16px',
    width: `calc(${window.screen.width}px - 32px)`,
    height: 40,
    borderRadius: 2,
    backgroundColor: '#ffffff',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ff970a',
    color: '#ff970a',
  },
  AddTrf: {
    textTransform: 'none',
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#ff970a',
  },
  // Individual trf box styles
  PendingCollectionsCard: {
    marginTop: '16px',
    backgroundColor: '#ffffff',
    borderRadius: 'none',
    boxShadow: 'none',
    paddingBottom: '76px',
  },
  PendingCHeading: {
    marginLeft: '16px',
    marginTop: '16px',
    height: 18,
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  PendingCats: {
    marginLeft: '16px',
    marginTop: '16px',
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  PendingBox: {
    display: 'flex',
    marginTop: '8px',
    marginLeft: '16px',
    width: `calc(${window.screen.width}px - 32px)`,
    height: 56,
    borderRadius: 2,
    backgroundColor: '#ffffff',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#f1f1f1',
    '#box-icon': {
      marginTop: '16px',
      marginLeft: '16px',
    },
  },
  TrfId: {
    width: `calc(${window.screen.width}px - 160px)`,
    marginLeft: '8px',
    marginTop: '11px',
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  TrfName: {
    width: 200,
    maxWidth: 200,
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#616161',
  },
  ScanButton: {
    marginTop: '16px',
    width: 64,
    height: 24,
    borderRadius: 2,
    backgroundColor: '#ffffff',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#ff970a',
  },
  ScanText: {
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#ff970a',
  },
  ScanIcon: {
    marginRight: '4px',
    color: '#ff970a',
    maxWidth: 16,
    marginTop: '11px',
  },
  ScanIconRec: {
    marginRight: '4px',
    color: '#ff970a',
    maxWidth: 16,
    marginTop: '7px',
  },
  ScanIconDone: {
    marginLeft: '32px',
    color: '#ff970a',
    maxWidth: 16,
    marginTop: '11px',
  },
  BottomCard: {
    boxShadow: '0 4px 8px 0 rgb(0 0 0 / 50%)',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    height: 80,
    backgroundColor: '#ffffff',
    alignContent: 'center',
    display: 'grid',
  },
  SubmitButton: {
    marginLeft: '16px',
    width: 'calc(100% - 32px)',
    height: 48,
    borderRadius: 2,
    backgroundColor: '#d2d2d2',
    ':hover': {
      backgroundColor: '#d2d2d2',
      color: '#fff',
    },
  },
  SubmitButtonEnabled: {
    marginLeft: '16px',
    width: 'calc(100% - 32px)',
    height: 48,
    borderRadius: 2,
    backgroundColor: '#ff970a',
  },
  CreateNewForm: {
    marginLeft: '16px',
    width: 'calc(100% - 32px)',
    height: 48,
    color: 'black',
    borderRadius: 2,
    border: '1px solid #ff970a',
    backgroundColor: '#fff',
  },
  SubmitText: {
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#ffffff',
  },
  CreateFormText: {
    textTransform: 'none',
    height: 20,
    fontFamily: 'Montserrat',
    fontSize: 13,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#ff970a',
  },
  TrfAddIndividual: {
    paddingTop: '12px',
    paddingBottom: '12px',
    display: 'flex',
    '#doctrf-icon': {
      marginTop: '12px',
      marginLeft: '16px',
    },
  },
  TrfAddIndividualNonRegular: {
    height: 88,
    display: 'flex',
    '#doctrf-icon': {
      marginTop: '12px',
      marginLeft: '16px',
    },
  },
  OldIdBadge: {
    marginTop: '8px',
    height: 24,
    maxWidth: 160,
    borderRadius: 4,
    backgroundColor: 'rgba(1, 179, 122, 0.05)',
    display: 'grid',
    alignContent: 'center',
  },
  BadgeText: {
    marginLeft: '8px',
    height: 14,
    fontFamily: 'Montserrat',
    fontSize: 10,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#01b37a',
  },
  TrfIdCollection: {
    width: `calc(${window.screen.width}px - 120px)`,
    marginLeft: '8px',
    marginTop: '15px',
    height: 16,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  EyeIcon: {
    marginTop: '2.5px',
    // marginLeft: '16px',
    color: '#3c3c3c',
    fontSize: '18px',
  },
  EyeIconHidden: {
    display: 'none',
    marginTop: '2.5px',
    marginLeft: '16px',
    color: '#3c3c3c',
    fontSize: '18px',
  },
  DeleteModal: {
    marginTop: '9px',
    '.MuiList-root': {
      padding: 0,
      maxHeight: '40px',
    },
  },
  DeleteText: {
    maxHeight: 40,
    height: 40,
    minHeight: 1,
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#fe0a0a',
  },
  dialogPaperProps: {
    borderRadius: '12px',
    maxWidth: '600px',
    width: 312,
    alignItems: 'center',
  },
  uploadHomeDelete: {
    paddingTop: '22px',
    borderRadius: '12px',
    maxWidth: '600px',
    width: 312,
    alignItems: 'center',
  },
  SuccessBox: {
    margin: '0 auto',
    marginTop: '8px',
    width: `${window.screen.width - 50}px`,
    height: 302,
    borderRadius: '16px',
    backgroundColor: '#ebf9f5',
  },
  SuccessCard: {
    marginTop: '16px',
    marginBottom: '16px',
    height: 320,
    backgroundColor: '#fff',
  },
  SuccessIcon: {
    textAlign: 'center',
    '#tick': {
      marginTop: '60px',
    },
  },
  SuccessText: {
    marginTop: '14px',
    fontFamily: 'Montserrat',
    fontSize: 18,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#3c3c3c',
  },
  SuccessSubText: {
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#616161',
  },
  SuccessSubTextBold: {
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#616161',
  },
};

export const CustomPaperStyles = {
  marginTop: '8px',
  fontFamily: 'Montserrat',
  fontSize: 12,
  fontWeight: '500',
  fontStyle: 'normal',
  letterSpacing: 0,
  borderRadius: 2,
  color: '#3c3c3c',
  '.MuiAutocomplete-listbox': {
    maxHeight: '144px',
    padding: '0px 0',
    borderRadius: 2,
  },
};

export const DeleteDialog = {
  Title: {
    marginTop: '24px',
    width: 264,
    height: 20,
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#3c3c3c',
  },
  AreUSure: {
    marginTop: '8px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#474747',
  },
  AreUSureBold: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '700',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#474747',
  },
  YesDelete: {
    width: '246px',
    backgroundColor: '#ff970a',
    color: 'white',
    marginTop: '24px',
    boxShadow: '0 0 5px #ff970a',
    borderRadius: '12px',
    minHeight: '50px',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#ff970a',
      color: 'white',
    },
    fontFamily: 'Montserrat',
    textTransform: 'none',
    fontSize: '15px',
  },
  Cancel: {
    minWidth: '100%',
    color: '#818181',
    marginTop: '16px',
    marginBottom: '12px',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    textTransform: 'none',
    lineHeight: '18px',
  },
  UploadCancel: {
    minWidth: '100%',
    color: '#818181',
    marginTop: '12px',
    marginBottom: '12px',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    textTransform: 'none',
    lineHeight: '18px',
  },
};
